import React from "react";

const EyePositionHeading = () => (
  <div className="mdc-layout-grid__inner">
    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-3"></div>
    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
      <b>Right</b>
    </div>

    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
      <b>Left</b>
    </div>
  </div>
);

export default EyePositionHeading;
